import { useMemo } from "react";
import { useTaxonomyContext } from "../../../../contexts/Taxonomy/TaxonomyContext";

export const useFilteredVendors = (searchTerm: string) => {
  const { vendors, vendorsLoading } = useTaxonomyContext();
  return useMemo(() => {
    if (!vendorsLoading && searchTerm && searchTerm.length >= 2) {
      const filteredVendors = vendors.filter((vendor) =>
        vendor.name.toLowerCase().includes(searchTerm)
      );

      return filteredVendors.sort((a, b) => {
        const aName = a.name.toLowerCase();
        const bName = b.name.toLowerCase();

        const diff =
          aName.indexOf(searchTerm) - bName.toLowerCase().indexOf(searchTerm);

        return diff || aName.localeCompare(bName);
      });
    }

    return [];
  }, [vendors, searchTerm, vendorsLoading]);
};
